var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.156 51H237.156V166.881L237.079 167.758C236.955 169.157 236.948 171.245 237.251 173.527C237.556 175.825 238.104 177.781 238.762 179.216C239.405 180.618 239.933 181.065 240.032 181.141C240.08 181.177 240.149 181.225 240.315 181.285C240.488 181.348 240.938 181.484 241.786 181.532C252.814 182.156 261.248 191.602 260.624 202.63C260 213.658 250.554 222.092 239.526 221.468C219.951 220.36 208.121 208.364 202.4 195.884C197.397 184.969 196.589 173.198 197.156 165.215V51H217.156Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M237.156 55V166.881L237.079 167.758C236.955 169.157 236.948 171.244 237.251 173.527C237.556 175.825 238.104 177.781 238.762 179.216C239.405 180.618 239.933 181.065 240.032 181.141C240.08 181.177 240.149 181.225 240.315 181.285C240.488 181.348 240.938 181.484 241.786 181.532C252.814 182.156 261.248 191.602 260.624 202.63C260 213.658 250.554 222.092 239.526 221.468C219.951 220.36 208.121 208.364 202.4 195.884C197.397 184.969 196.589 173.198 197.156 165.215V55",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.863 336.073C156.976 335.24 175.301 341.664 186.537 347.588C196.308 352.74 200.052 364.837 194.9 374.607C189.749 384.378 177.652 388.122 167.881 382.971C160.783 379.228 149.558 375.602 139.605 376.035C131.323 376.396 124.828 379.234 120.37 388.117C119.072 392.647 118.278 399.834 119.949 406.514C121.508 412.747 125.155 418.837 134.615 422.908L118.803 459.65C96.6632 450.122 85.3936 433.211 81.1441 416.219C77.1372 400.197 79.3737 384.54 82.7354 374.455L83.0834 373.411L83.5439 372.411C95.477 346.507 117.39 336.965 137.863 336.073Z",
    fill: "#F9F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.615 422.908C125.155 418.837 121.508 412.747 119.949 406.514C118.278 399.834 119.072 392.647 120.37 388.117C124.828 379.234 131.323 376.396 139.605 376.035C149.558 375.602 160.783 379.228 167.881 382.971C177.652 388.122 189.749 384.378 194.9 374.607C200.052 364.837 196.308 352.74 186.537 347.588C175.301 341.664 156.976 335.24 137.863 336.073C117.39 336.965 95.477 346.507 83.5439 372.411L83.0834 373.411L82.7354 374.455C79.3737 384.54 77.1372 400.197 81.1441 416.219C85.3936 433.211 96.6632 450.122 118.803 459.65",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M287.708 179.5C251.308 185.5 236.08 207.5 243.208 231C254.008 266.6 247.708 293.833 243.208 303C228.808 337.4 209.009 327.5 184.209 327.5C159.409 327.5 157.542 349.833 159.709 361C164.109 403.8 229.209 412.167 261.209 411C346.809 404.6 376.875 322.333 381.209 282C390.009 184 322.542 172.833 287.708 179.5Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M375.998 271.298C367.059 400.764 259.334 419.89 240.113 396.351C231.102 373 252.628 364.55 272.296 354.176C328.081 324.752 316.102 267.048 303.139 241.874C286.69 213.626 304.033 194.468 314.761 188.42C363 183.5 376.147 241.056 375.998 271.298Z",
    fill: "#EAEAEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M401.434 210.586L427.881 89L378.718 149.011L359.063 134.646L331.119 262.919L382.325 196.011L401.434 210.586Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M324.585 416.32L405.104 457.829L372.167 411.947L385.973 400.832L301.032 357.011L338.436 405.628L324.585 416.32Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M456.076 272.384C458.746 269.931 459.236 265.527 457.171 262.548C455.106 259.568 451.268 259.14 448.598 261.592L440.611 268.928L432.766 262.375C429.993 260.058 426.136 260.649 424.153 263.695C422.169 266.742 422.81 271.09 425.583 273.407L430.9 277.848L425.504 282.804C422.833 285.257 422.343 289.66 424.408 292.64C426.473 295.62 430.311 296.048 432.981 293.595L440.968 286.259L448.812 292.812C451.586 295.129 455.442 294.538 457.426 291.492C459.41 288.446 458.769 284.098 455.995 281.781L450.68 277.34L456.076 272.384Z",
    fill: "#1C1B1F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.076 454.384C306.746 451.931 307.236 447.527 305.171 444.548C303.106 441.568 299.268 441.14 296.598 443.592L288.611 450.928L280.766 444.375C277.993 442.058 274.136 442.649 272.153 445.695C270.169 448.742 270.81 453.09 273.583 455.407L278.9 459.848L273.504 464.804C270.833 467.257 270.343 471.66 272.408 474.64C274.473 477.62 278.311 478.048 280.981 475.595L288.968 468.259L296.812 474.812C299.586 477.129 303.442 476.538 305.426 473.492C307.41 470.446 306.769 466.098 303.995 463.781L298.68 459.34L304.076 454.384Z",
    fill: "#1C1B1F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 306.5,
    cy: 120.5,
    r: 17.5,
    fill: "#1C1B1F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 440.5,
    cy: 397.5,
    r: 17.5,
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/내과_만성위염.2229e8f957001cfae7bea51857899337.svg";
export { ForwardRef as ReactComponent };